import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export type SelectionPluginState = {
	nonCursorSelectionChangeCount: number;
};

export const selectionPluginKey = new PluginKey<SelectionPluginState>('aiExperienceSelection');
